import {NgModule} from "@angular/core";
import {MatDividerModule} from "@angular/material/divider";
import {Routes} from "@angular/router";
import {AdminGuardProvider} from "@core/security/admin-guard.provider";
import {TranslateModule} from '@ngx-translate/core';
import {PreviewAlerteModule} from "@share/component/alerte/preview-alerte.module";
import {LoginService} from "@share/login/login.service";
import {ShareModule} from "@share/share.module";
import {ProfilService} from "../../../profil/profil.service";
import {MatLegacyRadioModule as MatRadioModule} from "@angular/material/legacy-radio";
import {ApiSoapComponent} from "./soap/api-soap.component";
import {ApiRestComponent} from "./rest/api-rest.component";
import {ApiClefsComponent} from "./clefs/api-clefs.component";
import {ParametreApiComponent} from "@components/admin/parametre/api/parametre-api.component";
import {ApiPartenairesComponent} from "@components/admin/parametre/api/partenaires/api-partenaires.component";
import {ApiRseService} from "@services/admin/parametre/api/api-rse.service";
import {ApiClefsService} from "@services/admin/parametre/api/api-clefs.service";
import {ApiPartenairesPopupTestComponent} from "@components/admin/parametre/api/partenaires/popup-test/api-partenaires-popup-test.component";
import {RseIframeModule} from "@share/component/rse-iframe/rse-iframe.module";
import {ApiRestListItemComponent} from "@components/admin/parametre/api/rest/api-rest-list-item/api-rest-list-item.component";
import {ApiRestService} from "@services/admin/parametre/api/api-rest.service";
import {ApiRestDetailsComponent} from "@components/admin/parametre/api/rest/api-rest-details/api-rest-details.component";
import {PageHeaderModule} from "@share/component/page-header/page-header.module";
import {LayoutModule} from "@share/layout/layout.module";
import {ApiRestDetailsCompteComponent} from "@components/admin/parametre/api/rest/api-rest-details/api-rest-details-compte/api-rest-details-compte.component";
import {ApiRestDetailsService} from "@components/admin/parametre/api/rest/api-rest-details/api-rest-details.service";
import {ApiRestDetailsDroitsComponent} from "@components/admin/parametre/api/rest/api-rest-details/api-rest-details-droits/api-rest-details-droits.component";
import {ApiClefItem} from "./clefs/item/api-clef-item.component";
import {DroitAdmin} from "@core/security/droit-admin";
import {ApiClefAddComponent} from "@components/admin/parametre/api/clefs/add/api-clef-add.component";
import {ApiSoapService} from "@services/admin/parametre/api/api-soap.service";

export const parametreApiRoutes: Routes = [
	{
		path: 'Rest',
		component: ApiRestComponent,
		canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_INTERFACE_COMPTE_API] }
	},{
        path: 'Rest/:idCompte',
        component: ApiRestDetailsComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_INTERFACE_COMPTE_API], hideHeader: true }
    },{
		path: 'Soap',
		component: ApiSoapComponent,
		canActivate: [AdminGuardProvider]
	},{
		path: 'Clefs',
		component: ApiClefsComponent,
		canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_INTERFACE_REF] }
    },{
        path: 'Partenaires',
        component: ApiPartenairesComponent,
        canActivate: [AdminGuardProvider]
	},{
		path: '',
		pathMatch: 'full',
		redirectTo: 'Rest'
	},{
		path: '**',
		redirectTo: 'Rest'
	}
];

@NgModule({
    imports: [ShareModule,PreviewAlerteModule,MatDividerModule,TranslateModule,MatRadioModule,RseIframeModule,LayoutModule,PageHeaderModule],
	declarations: [
        ApiRestComponent,ApiSoapComponent,ApiClefsComponent,ParametreApiComponent,ApiPartenairesComponent,ApiPartenairesPopupTestComponent,ApiRestListItemComponent,ApiRestDetailsComponent,ApiRestDetailsCompteComponent,ApiRestDetailsDroitsComponent,ApiClefItem,ApiClefAddComponent
	],
	exports: [
        ApiRestComponent,ApiSoapComponent,ApiClefsComponent,ApiPartenairesComponent,ApiRestListItemComponent,ApiRestDetailsComponent,ApiRestDetailsCompteComponent,ApiRestDetailsDroitsComponent,
	],
    providers: [ProfilService, LoginService, ApiRseService, ApiRestService, ApiRestDetailsService, ApiClefsService, ApiSoapService]
})
export class ParametreApiModule {
}